// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"907c8d8d","488":"d5bf51c2","796":"81c00556"}[chunkId] + ".chunk.js";
};